import dynaForms from '@elab/core/utils/dynaForms';
import { reduceAction } from '@elab/core/store/helpers';
import { initialState as dynaInitialState } from '@elab/core/utils/dynaForms/reducers';

import types, { storeName } from './types';

export const initialState = (state, initialData) => ({
    ...dynaInitialState(state),
    ...initialData,
    verificationState: false,
    shareEmailId: '',
});

const dynaFormReduce = dynaForms.createReducer(storeName);

const reducers = (state = initialState(), action) => {
    state = dynaFormReduce(state, action);

    switch (action.type) {
        case types.SET_VERIFICATION_STATE:
            return reduceAction(state, 'verificationState', action.payload);

        case types.SET_SHARE_EMAIL_ID:
            return reduceAction(state, 'shareEmailId', action.payload);
        default:
            return state;
    }
};

export default reducers;
